import { z } from "zod";
export const cancellationDecisionSchema = z.object({
    approve: z.boolean(),
    host_note: z.string().max(2000).optional(),
});
